import { http } from '../utils/http'

const getkeyVaultList = (params) => {
    const url = '/config/keyVault/page'
    return http.post(url, params)
};

const lockAction = (params) => {
    const url = '/config/keyVault/updateStatus'
    return http.post(url, params)
};

const saveKeyVault = (params) => {
    const url = '/config/keyVault/save'
    return http.post(url, params)
};

const getInfoAction = (id) => {
    const url = `/config/keyVault/getInfo/${id}`
    return http.post(url)
};

const getApplicationNameList = () => {
    const url = `/config/keyVault/getApplicationName`
    return http.post(url)
};

export default {
    getkeyVaultList,
    lockAction,
    saveKeyVault,
    getInfoAction,
    getApplicationNameList
}
